var latestNews = latestNews || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F();
        };
    })();
}

jQuery(function ( $ ) {
 
    $.fn.hpLatest = function( options ) {
        return this.each(function() {
            var hpLatest = Object.create(latestNews.hpLatest);
            hpLatest.init(this, options);
        });
    };

    $.fn.hpLatest.options = {

     };

    latestNews.hpLatest = {

        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);
            self.$itemWrap = self.$container.find(".latest-list");
            self.$item = self.$itemWrap.find(".latest-list__item");
            
            self.$current = self.$container.find(".latest-ticker__current");
            self.$total = self.$container.find(".latest-ticker__total");
            
            self.$sliderSettings = {
                dots: false,
                arrows: false,
                infinite: false,
                speed: 400,
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnSelect: false
            };

            self.bindElements();
 
        },

        bindElements () {
            var self = this;

            $(window).on('resize', function() {

                if ($(window).width() >= 768 && $(window).width() <= 1024) {
                    if (!self.$itemWrap.hasClass('slick-initialized')) {
                        self.setSlider()
                        self.killWaypoints();
 
                    }
                } else {
                    self.setWaypoints();
                    if (self.$itemWrap.hasClass('slick-initialized')) {
                        self.$itemWrap.slick('unslick');
 
                    }
                }
            }).trigger("resize");
        },

        setSlider() {
            var self = this;

            self.$itemWrap.on("init", function(event, slick) {
                if( slick.slideCount > 1 ) {
                    self.$current.text( slick.currentSlide + 1).addClass("show");
                    self.$total.text( slick.slideCount );
                } 
            });
            
            self.$itemWrap.on("beforeChange", function(event, slick, currentSlide) {
                self.$current.removeClass("show").addClass("animate-out").removeClass("animate-out");
            });

            self.$itemWrap.on("afterChange", function(event, slick, currentSlide) {
                self.$current.text( slick.currentSlide + 1 ).addClass("show");
            });

            self.$itemWrap.slick( self.$sliderSettings );
        },

        setWaypoints() {
            var self = this;

            self.$itemWrap.addClass("animate-in");
            self.$waypoints = self.$item.waypoint(function(direction) {
                if ( direction === 'down') {
                    $(this.element).addClass("show-item");
                }
            }, {
              offset: "75%"
            });
           
        },

        killWaypoints() {
            var self = this;
            self.$itemWrap.removeClass("animate-in")
        }
    };
});
